<template>
    <base-button
        data-testid="button-default"
        v-bind="$attrs"
        fixed-width="w-37"
        :type="type"
        v-on="listeners"
    >
        <slot>
            <div class="flex items-center">
                <slot
                    v-if="$slots.icon || icon"
                    name="icon"
                >
                    <component
                        :is="icon"
                        v-if="icon"
                        class="mx-1"
                    />
                </slot>
                <span class="mx-1">{{ label }}</span>
            </div>
        </slot>
    </base-button>
</template>

<script>
export default {
    components: {
        BaseButton: () => import('@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue')
    },
    props: {
        icon: {
            type: String,
            default: 'IconConfirm'
        },
        label: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'default'
        },
        color: {
            type: String,
            default: 'primary'
        }
    },
    computed: {
        listeners () {
            return {
                ...this.$listeners,
                click: this.onClick
            }
        }
    },
    methods: {
        onClick () {
            this.$emit('on-click')
        }
    }
}
</script>
